import ContentLoader from 'react-content-loader';

const PostLoader = (props) => (
  <ContentLoader height={475} width={400} speed={2} primaryColor="#f3f3f3" secondaryColor="#ecebeb" {...props}>
    <rect x="5" y="7.64" rx="0" ry="0" width="391.24799999999993" height="14.867999999999999" />
    <rect x="41.4" y="239.64" rx="0" ry="0" width="0" height="0" />
    <rect x="4.87" y="27.23" rx="0" ry="0" width="115.36" height="12.5248" />
    <rect x="5.35" y="46.64" rx="0" ry="0" width="390.5631" height="21.106799999999996" />
    <rect x="280.87" y="27.23" rx="0" ry="0" width="115.36" height="12.5248" />
    <rect x="5.35" y="80.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="96.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="111.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="126.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="141.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="155.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="187.64" rx="0" ry="0" width="390.5631" height="47.8764" />
    <rect x="6.35" y="258.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="273.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="288.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="303.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="319.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="334.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="349.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="364.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="379.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="393.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="408.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="423.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="438.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="453.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="169.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
    <rect x="6.35" y="242.64" rx="0" ry="0" width="390.5631" height="10.810799999999999" />
  </ContentLoader>
);

export default PostLoader;
